// File: src/components/Cards/ProductCardCompetitorWrapper.tsx

import React from "react";
import AsyncProductCard from "./AsyncProductCard";
import FadeIn from "./FadeIn";
import "./CompetitorTable.css"; // Optional CSS for table styling

interface CompetitorDetail {
    competitor_name: string;
    competitor_price: string;
    competitor_availability: string;
    competitor_sku: string;
    competitor_url?: string;
}

interface CompetitorProduct {
    skuid: string;
    competitor_details: CompetitorDetail[];
}

interface ProductCardCompetitorWrapperProps {
    competitorProduct: CompetitorProduct;
    onCitationClicked: (citationFilePath: string) => void;
    spinnerActive: boolean;
    priceSource: "web" | "store";
    siteId: "PUBLIC_GR" | "PUBLIC_CY";
}

const ProductCardCompetitorWrapper: React.FC<ProductCardCompetitorWrapperProps> = ({ competitorProduct, onCitationClicked, spinnerActive, priceSource, siteId }) => {
    const { skuid, competitor_details } = competitorProduct;
    return (
        <div style={{ marginBottom: "24px" }}>
            <FadeIn>
                {/* Render product details for this SKU */}
                <AsyncProductCard
                    sku={skuid}
                    onCitationClicked={onCitationClicked}
                    spinnerActive={spinnerActive}
                    priceSource={priceSource}
                    siteId={siteId}
                />
            </FadeIn>
            {competitor_details && competitor_details.length > 0 && (
                <FadeIn>
                    <div
                        style={{
                            marginTop: "8px",
                            padding: "12px 16px",
                            backgroundColor: "var(--bg-secondary)",
                            borderRadius: "8px",
                            border: "1px solid var(--border-primary)"
                        }}
                    >
                        <table className="competitor-table">
                            <thead>
                                <tr>
                                    <th>Competitor Name</th>
                                    <th>SKU</th>
                                    <th>Price</th>
                                    <th>Availability</th>
                                    <th>Link</th>
                                </tr>
                            </thead>
                            <tbody>
                                {competitor_details.map((detail, idx) => (
                                    <tr key={idx}>
                                        <td>{detail.competitor_name}</td>
                                        <td>{detail.competitor_sku}</td>
                                        <td>{detail.competitor_price} €</td>
                                        <td>{detail.competitor_availability}</td>
                                        <td>
                                            {detail.competitor_url ? (
                                                <a href={detail.competitor_url} target="_blank" rel="noopener noreferrer">
                                                    Visit
                                                </a>
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </FadeIn>
            )}
        </div>
    );
};

export default ProductCardCompetitorWrapper;
